import { createContext } from 'react';

const FilterPanelContext = /*#__PURE__*/createContext(undefined);

export default FilterPanelContext;
